// eslint:disable max-line-length
import { CodetableMetadata, CodetableAdministrationState, AccessCodetables, CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { FilterOption } from 'app/components/options-handler/types';
import { CodetableSelectorProps, IndicatorFactorsPicker } from 'app/area/indicator-factors/types';
import { LoadOptions } from 'app/types-shared';
import { Value } from 'app/types-shared';
import { CodeItem } from 'app/area/indicator-factors/item/types-store';
import { CodetableOptions, LoadCodeItemsParams } from 'app/area/indicator-factors/common';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { ValidationProps } from 'ui';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export interface CodeItemValueWire {
  v: number;
  d?: string;
  disabled?: string;
  readOnly?: boolean;
}

export interface CodeItemWire {
  code?: Value;
  validFrom?: string;
  substanceCategory?: CodeItemValueWire;
  substance?: CodeItemValueWire;
  substanceUom?: CodeItemValueWire;
  indicatorSubstanceCategory?: CodeItemValueWire;
  indicatorSubstance?: CodeItemValueWire;
  indicatorSubstanceUom?: CodeItemValueWire;
  indicatorType?: CodeItemValueWire;
  location?: CodeItemValueWire;
  unit?: CodeItemValueWire;
  equipment?: CodeItemValueWire;
  source?: CodeItemValueWire;
  factor?: number;
}

export interface CodeToWire {
  codeItem: CodeItem;
}

export interface SaveCodetableItem {
  codetableId: number;
  breadcrumbs: number[];
  metadata: CodetableMetadata;
  options: { [key: string]: FilterOption };
  validationErrorMessage: string;
  actionType: CodeActionType;
}

export type LoadCodetableOptions = (id: string, codetableId: number,
  loadOptionsParams: LoadOptions, optionsParams?: LoadCodeItemsParams) => any;

export type LoadCodetableItemAccess = (codetableId: number) => void;

export type LoadCodeOptions = (id: string, componentEndpoint: string,
  loadOptionsParams: LoadOptions, optionsParams?: LoadCodeItemsParams) => void;

export type LoadCodeItem = (payload: CodetableSelectorProps) => void;

export type CreateCodeItem = (payload: CodetableSelectorProps) => void;

export type CreateCodeItemProps = CodetableSelectorProps
  & { loadCodeItem: LoadCodeItem }
  & { createCodeItem: CreateCodeItem }
  & { loadOptions: LoadCodeOptions }
  & { loadCodetableOptions: LoadCodetableOptions };

export interface InitializeCodeItemPayload extends CodetableAdministrationState {
  breadcrumbs: number[];
  codetableId: number;
  codeId: number;
  categoryId: number;
  parentId: number;
  actionType: CodeActionType;
  options: { [key: string]: FilterOption };
  createCodeItem: () => void;
  loadCodeItem: LoadCodeItem;
  loadOptions: (id: string, componentEndpoint: string, loadOptionsParams: LoadOptions, optionsParams?: LoadCodeItemsParams) => void;
  loadCodetableOptions: LoadCodetableOptions;
  codetableBlockAccess: (breadcrumbs: number[]) => void;
  clearValidation: () => void;
}

export interface SubstanceUomSet {
  uom: CodeItemValueWire;
  uomIndicator: CodeItemValueWire;
  uomSet: CodeItemValueWire;
  uomType: CodeItemValueWire;
  uomTypeIndicator: CodeItemValueWire;
}

export enum CodeActionType {
  Add = 'add',
  Edit = 'edit',
  Duplicate = 'duplicate'
}

export enum ReadOnlyType {
  all = 'all',
  save = 'save'
}

export interface CodeItemCodesAccess {
  id: number;
  edit: boolean;
  move: boolean;
  delete: boolean;
  readonlySubsets?: number[];
}

export interface ReadOnlyConfigurationValue {
  codeId?: number;
  actionType?: CodeActionType;
  canMove?: boolean;
  canCreate?: boolean;
  administrationCentral?: boolean;
  canEdit?: boolean;
  codetableMetadata?: CodetableMetadata;
}

export type ReadOnlyConfiguration = { [key: string]: boolean };

export interface CodeItemAccessConfiguration {
  canCreate: boolean;
  canDuplicate: boolean;
  canDelete: boolean;
  canEdit: boolean;
  isCentralAdmin: boolean;
}

export interface IndicatorFactorsScreenRendererProps {
  breadcrumbs: number[];
  codetableId: number;
  actionType: CodeActionType;
  codeItem: CodeItem;
  originalCodeItem: CodeItem;
  metadata: CodetableMetadata;
  language: CodeComplexValue<number>;
  locale: string;
  translation: CodetableTranslation;
  codetableOptions: { [key: string]: CodetableOptions };
  options: { [key: string]: FilterOption };
  validation: { [key: string]: ValidationProps };
  readOnlyConfig?: ReadOnlyConfiguration;
  codetableItemAccess?: AccessCodetables;
  shouldPrompt?: boolean;
  savingCodetableItem?: boolean;
  clearValidation: () => void;
  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams) => void;
  loadOptions: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateByKey?: <T>(key: IndicatorFactorsPicker | CodeFieldWireKey, value: T) => void;
  resetValidation?: (key: CodeFieldWireKey) => void;
}

export interface ClearAllValidation {
  codetableKey: CodeFieldWireKey;
  validation: { [key: string]: ValidationProps };
  clearValidation: () => void;
}
